export const AssociateStatus = {
  none: 'None',
  workSummaryAccepted: 'Work Summary Accepted',
  appraisalFormFilled: 'Appraisal Form Filled',
  managerFeedbackFilled: 'Manager Feedback Filled',
  completed: 'Completed',
};
